import { useEffect, useState } from "react";

let deferred = null;
const EVT = "app:installable";

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event(EVT)); });
  window.addEventListener("appinstalled", () => { deferred = null; window.dispatchEvent(new Event(EVT)); });
}

export const isInstalled = () => localStorage.getItem("orbit_desktop") === "1" || window.matchMedia?.("(display-mode: standalone)").matches || window.matchMedia?.("(display-mode: window-controls-overlay)").matches || window.navigator.standalone === true;

export const promptInstall = async () => {
  if (!deferred) return "unavailable";
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  window.dispatchEvent(new Event(EVT));
  return outcome;
};

export function useInstallable() {
  const [ready, setReady] = useState(!!deferred);
  useEffect(() => { const h = () => setReady(!!deferred); window.addEventListener(EVT, h); return () => window.removeEventListener(EVT, h); }, []);
  return ready;
}
